export default "__VITE_ASSET__AJLXqw1s__"